export const trainingConfig = {
  triathlon: {
    label: 'Triathlon',
    distances: {
      XS: ['4'],
      "XS-S": ['4'],
      S: ['4', '6', '8'],
      M: ['6', '8', '10'],
      L: ['8', '10', '12'],
      IM: ['12', '15'],
    },
  },
  duathlon: {
    label: 'Duathlon',
    distances: {
      S: ['6', '8'],
      M: ['6', '8'],
      L: ['8', '10'],
    },
  },
  running: {
    label: 'Course à pied',
    distances: {
      '5km': ['4', '6', '8'],
      '10km': ['4', '6', '8'],
      '21km': ['6', '8', '10'],
      '42km': ['6', '8', '10'],
    },
  }
} as const;

export type TrainingConfig = typeof trainingConfig;

export type AllDisciplines = keyof TrainingConfig;
type DistancesFor<D extends AllDisciplines> = TrainingConfig[D]['distances'];
export type Distance<D extends AllDisciplines> = keyof DistancesFor<D> & string;

type VolumesFor<D extends AllDisciplines, Dist extends keyof DistancesFor<D> & string> = 
  DistancesFor<D>[Dist] extends readonly (infer V)[]
    ? V extends string
      ? V
      : never
    : never;

export type Keyword = {
  [D in AllDisciplines]: {
    [Dist in keyof DistancesFor<D> & string]:
      `${D},${Dist},${VolumesFor<D, Dist>}`
  }[keyof DistancesFor<D> & string]
}[AllDisciplines];


export const disciplineLabels = Object.fromEntries(
  Object.entries(trainingConfig).map(([k, v]) => [k, v.label])
) as Record<AllDisciplines, string>;

export type AllDistances = {
  [D in AllDisciplines]: keyof TrainingConfig[D]['distances']
}[AllDisciplines] & string;


export type AllVolumes = {
  [D in AllDisciplines]: {
    [Dist in keyof DistancesFor<D> & string]: VolumesFor<D, Dist>
  }[keyof DistancesFor<D> & string]
}[AllDisciplines];

export const allKeywords: Keyword[] = Object.entries(trainingConfig)
  .flatMap(([discipline, { distances }]) =>
    Object.entries(distances).flatMap(([distance, volumes]) =>
      (volumes as readonly string[]).map((volume: string) =>
        `${discipline},${distance},${volume}` as Keyword
      )
    )
  );

export const allPrimitiveValues = Array.from(new Set(
  Object.entries(trainingConfig).flatMap(([discipline, { distances }]) =>
    [discipline, ...Object.entries(distances).flatMap(
      ([distance, volumes]) => [distance, ...volumes]
    )]
  )
));

export const DistanceCategoryMap: Record<AllDistances, 'SHORT' | 'LONG'> = {
  XS: 'SHORT',
  'XS-S': 'SHORT',
  S: 'SHORT',
  M: 'SHORT',
  L: 'LONG',
  IM: 'LONG',
  '5km': 'SHORT',
  '10km': 'SHORT',
  '21km': 'SHORT',
  '42km': 'LONG'
}

export const DistanceKeywordMap: Record<AllDistances, string[]> = {
  XS: ["XS"],
  'XS-S': ["XS-S"],
  S: ["S"],
  M: ["M"],
  L: ['L'],
  "IM": ["IM"],
  '5km': ['5km'],
  '10km': ['10km'] ,
  '21km': ['21km'],
  '42km': ['42km']
};
